// src/environment/environment.prod.js
const environment = {
  // API_URL: "http://192.168.0.118:9090/",
  API_URL: "https://halrayarmutt.com/api/",
};

export default environment;
